import classNames from "classnames";
import { If } from "react-conditional-components-renderer";
import styles from "./AscTextInput.module.scss";
import { forwardRef } from "react";
type AscTextInputSize = "small" | "medium" | "large";

export interface AscTextInputProps
  extends Omit<
    React.DetailedHTMLProps<
      React.InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >,
    "size"
  > {
  size?: AscTextInputSize;
  innerInputClassName?: string;
  inputWrapperClassName?: string;
  className?: string;
  fullWidth?: boolean;
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
  suffixComponent?: React.ReactNode;
  onParentDivClick?: () => void;
  onTextChange?: (value: string) => void;
  setFieldValue?: (value: string) => void;
}

const AscTextInput = forwardRef<HTMLInputElement, AscTextInputProps>(
  (
    {
      size = "medium",
      className,
      innerInputClassName,
      inputWrapperClassName,
      fullWidth = false,
      prefixIcon,
      suffixIcon,
      suffixComponent,
      onParentDivClick,
      onTextChange,
      setFieldValue,
      ...rest
    },
    ref
  ) => {
    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
      rest?.onChange?.(e);
      onTextChange?.(e.target.value);
    }

    return (
      <div
        onClick={onParentDivClick}
        className={classNames(
          styles.ground,
          {
            [styles.large]: size === "large",
            [styles.medium]: size === "medium",
            [styles.small]: size === "small",
            [styles.disabled]: rest?.disabled,
            [styles.fullWidth]: fullWidth,
          },
          className
        )}
      >
        <If test={!!prefixIcon}>
          <span className={styles.icon}>{prefixIcon}</span>
        </If>
        <div className={classNames(styles.inputWrapper, inputWrapperClassName)}>
          <input
            ref={ref}
            className={classNames(styles.innerInput, innerInputClassName)}
            {...rest}
            onChange={handleChange}
          />
        </div>
        <If test={!!suffixIcon}>
          <span className={styles.icon}>{suffixIcon}</span>
        </If>
        <If test={!suffixIcon && !!suffixComponent}>
          <div>{suffixComponent}</div>
        </If>
      </div>
    );
  }
);

export default AscTextInput;
